module.exports = __webpack_public_path__ + "static/img/sph.9235a84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sph.jpg
// module id = ArC+
// module chunks = 26